import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Header, Segment, List } from "semantic-ui-react";
import { GamButtons } from "../utils/buttons";
import { AdServeData } from "../../banner/ad-data";

const Info = () => {
  const banner = useSelector((state) => state.banner);
  const user = useSelector((state) => state.user);
  const template = useSelector((state) => state.template);

  const [variables, setVariables] = useState({});

  useEffect(() => {
    if (user) {
      const obj = Object.assign(
        ...template.variables.map((item) => ({
          [item.uniqueName]: { ...item },
        }))
      );
      setVariables({ ...obj });
    }
  }, [template, user]);

  useEffect(() => {
    if (!user) {
      if (banner.fields) {
        let obj = {};
        _.map(banner.fields, (field, index) => {
          obj[index] = { label: index };
        });
        setVariables({ ...obj });
      }
    }
  }, [banner, user]);

  return (
    <>
      {!_.isEmpty(variables) && (
        <Grid padded className="trade-info">
          {user && banner.adServeData && (
            <Grid.Row>
              <Grid.Column computer={16} tablet={16} mobile={16}>
                <AdServeData data={banner.adServeData} />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Banner info</Header>
              <Segment>
                <List divided celled size="medium">
                  <List.Item>
                    <List.Content>
                      <List.Header>Title</List.Header>
                      {banner.bannerTitle}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>Ad number</List.Header>
                      {banner.adNumber}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>Advertiser</List.Header>
                      {banner.advertiser}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      <List.Header>Banner link</List.Header>
                      {banner.bannerURL}
                    </List.Content>
                  </List.Item>
                </List>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Template fields</Header>
              <Segment>
                <List divided celled size="medium">
                  {_.map(
                    banner.fields,
                    (value, key) =>
                      !value.path &&
                      value.path !== "" &&
                      variables[key] && (
                        <List.Item key={key}>
                          <List.Content>
                            <List.Header>{variables[key].label}</List.Header>
                            {value.toString()}
                          </List.Content>
                        </List.Item>
                      )
                  )}
                </List>
              </Segment>
            </Grid.Column>
            <Grid.Column computer={4} tablet={8} mobile={16}>
              <Header as="h3">Images</Header>
              <Segment>
                <List divided celled size="medium">
                  {_.map(
                    banner.fields,
                    (value, key) =>
                      value.path && (
                        <List.Item key={key}>
                          <List.Content>
                            <List.Header>{variables[key].label}</List.Header>
                            <img src={value.path} alt={key} />
                          </List.Content>
                        </List.Item>
                      )
                  )}
                </List>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
      {user && user.isAdOps && <GamButtons banner={banner} service="gam" />}
    </>
  );
};

export default Info;
